import {Component, OnInit} from '@angular/core';
import {CoreService} from "../../../shared/services/core.service";
import {MainLayoutService} from "../../../shared/services/main-layout.service";
import {FacadeService} from "../../../shared/service-facade/facade.service";

@Component({
  selector: 'app-create-invitation',
  templateUrl: './create-invitation.component.html',
  styleUrls: ['./create-invitation.component.scss']
})
export class CreateInvitationComponent implements OnInit {
  constructor(
    private coreService: CoreService,
    private mainLayoutService: MainLayoutService,
    private facadeService: FacadeService,
  ) {
  }

  ngOnInit(): void {
    this.facadeService.isInJointMaintenanceFlow$.next(true);
    this.mainLayoutService.hideAppStoreBanner();
  }
}
